import { grey } from '@material-ui/core/colors';

export default () => ({ container: { backgroundColor: grey[100] } });
